import React, { useEffect } from 'react';
// import './style.scss';


const MuhammadAliScholarships = () => {

    useEffect(() => {

        const script = document.createElement('script');
        script.setAttribute(
          'src',
          'https://fs23.formsite.com/include/form/embedManager.js?865338212');
        script.addEventListener('load', () => {
          EmbedManager.embed({
            key: "https://fs23.formsite.com/res/showFormEmbed?EParam=m_OmK8apOTD5ovQ3l4B2taQhrZEvFr_3FzpUCZwnDno&865338212",
            width: "100%",
            showFormLogin: false,
            mobileResponsive: true
          });
        });
		document.getElementById('apply-form').appendChild(script);
    }, []);

    return (
        <div className='MA-Scholarship'>
            <div className='scholarship-container'>
                <div className='banner-container'>
                    <div className='scholarship-banner'>
                        <img src={`${process.env.IMAGES_BASE_URL}/static-content/muhammad-ali-left.png`} alt='Muhammad-ali' />
                        <p>
                            Bayan Muhammad Ali Spiritual <br/>
                            Leadership Full Tuition Scholarship
                        </p>
                        <img src={`${process.env.IMAGES_BASE_URL}/static-content/muhammad-ali-right.png`} alt='Muhammad-ali' />
                    </div>
                    <p>
                        The Bayan Muhammad Ali Spiritual Leadership Full Tuition Scholarship is an honor bestowed upon a deserving and highly qualified full-time entering graduate student enrolled in Bayan’s 48-unit Master of Arts (concentrations available in Islamic Studies, Islamic Leadership, Islamic Education, and Islamic Theology), or in the 75-unit Master of Divinity in Islamic Chaplaincy program.
                    </p>
                </div>
                <div className='scholar-info-container'>
                    <div className='scholarship-form' id='apply-form'>
                        <a name="form865338212" id="formAnchor865338212"></a>
                    </div>
                    <div className='scholarhip-info'>
                        <div className='scholarship-award'>
                        <span className='award-icon'><img src={`${process.env.IMAGES_BASE_URL}/static-content/noun_Award_16635.svg`} alt='award' /></span>
                        <h3>
                            Full-tuition Award:
                        </h3>
                        </div>
                        <p>
                            MA Students: $48,000 over 2 academic years<br/>
                            MDiv Students: $75,000 over 3 academic years<br/>
                            Funds are disbursed incrementally to cover tuition for all coursework during each semester.
                        </p>
                        <h3>
                            Eligibility:
                        </h3>
                        <p>
                            Student has been granted admission to Bayan's MA or MDiv. degree program at Chicago Theological Seminary<br/>
                            Student is a citizen/legal resident of the United States of America<br/>
                            Student is currently working on a full-time basis in an underserved community in the U.S.
                        </p>
                        <h3>
                            Application Requirements:
                        </h3>
                        <p>
                            Academic merit (entering cumulative GPA of 3.5 or above)
                            Personal vision statement (500 words)<br/>
                            Professional growth plan (500 words)<br/>
                            Demonstrated community service/leadership<br/>
                            Résumé (upload as attachment)<br/>
                            2 letters of recommendation (upload as attachments)
                        </p>
                        <h3>
                            Terms:
                        </h3>
                        <p>
                            Maintain Full-time enrollment (9-12 units/semester; 24 units/year)<br/>
                            Maintain 3.5 or higher cumulative GPA<br/>
                            Interruption of studies may result in termination of award.
                        </p>
                        <h3>
                            Deadlines:
                        </h3>
                        <p>
                            For Fall Term: July 1
                            <br/>
                            For Spring Term: December 1
                            <br/>
                            For Summer Term: April 1
                        </p>
                     </div>
                </div>
            </div>
        </div>
     );
}

export default MuhammadAliScholarships;
